import React from 'react';
import usePACMembershipData from 'hooks/usePACMembershipData';
import { Outlet, useNavigate } from 'react-router-dom';

const ProtectedAlumniRoute = () => {
  const navigate = useNavigate();
  const { userStatus } = usePACMembershipData();

  if (!userStatus.isEligibleForAlumniFeature) {
    return navigate('/program');
  }
  return <Outlet />;
};

export default ProtectedAlumniRoute;
